
import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTalentAuth } from '../../contexts/TalentAuthContext';

function Footer() {
  const { talent, isAuthenticated } = useTalentAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleSearchClick = (e: React.MouseEvent) => {
    if (location.pathname !== "/") {
      navigate("/?scroll=search");
    }
  };

  return (
    <footer className="premium-footer">
      {/* Main Footer Columns */}
      <div className="premium-footer-main">
        {/* Col 1: Logo + Tagline */}
        <div className="premium-footer-brand">
          <Link className="premium-footer-logo-link" to="/" style={{ textDecoration: 'none' }}>
            <div style={{ width: '32px', height: '32px', borderRadius: '8px', backgroundColor: '#185FA5', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <svg viewBox="0 0 24 24" fill="#FAC775" style={{ width: '20px', height: '20px' }}>
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
              </svg>
            </div>
            <span style={{ fontSize: '20px', fontWeight: '700', color: '#FAC775', marginLeft: '10px', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>SkillSeek</span>
          </Link>
          <p className="premium-footer-tagline">
            Connecting Skilled workers with clients across Jamaica.
          </p>
        </div>

        {/* Col 2: Quick Links */}
        <div className="premium-footer-col">
          <h4 className="premium-footer-col-title">Quick Links</h4>
          <ul className="premium-footer-col-links">
            <li><Link to="/listing">Find Workers</Link></li>
            <li><Link to="/talent/register">Register a worker</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Col 3: Legal */}
        <div className="premium-footer-col">
          <h4 className="premium-footer-col-title">Legal</h4>
          <ul className="premium-footer-col-links">
            <li><Link to="/terms">Terms & Conditions</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/refund-policy">Refund Policy</Link></li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="premium-footer-bottom">
        <p className="premium-footer-copyright">
          &copy; {new Date().getFullYear()} SkillSeek. All rights reserved.
        </p>
      </div>

      {/* Sticky footer for mobile bottom bar */}
      <div className='stick-footer'>
        <ul>
          <li className='active'>
            <a href={'#'} onClick={handleSearchClick}>
              <span>
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.93812 20.2245C9.84481 23.3535 15.5634 23.1072 19.1849 19.4857C23.0706 15.6 23.0706 9.3 19.1849 5.41429C15.2991 1.52857 8.99915 1.52857 5.11343 5.41429C1.49195 9.03577 1.24568 14.7543 4.37462 18.661L1.53648 21.5C1.10474 21.9317 1.10474 22.6317 1.53648 23.0635C1.96823 23.4952 2.66823 23.4952 3.09998 23.0635L5.93812 20.2245ZM17.6214 6.97778C20.6436 10 20.6436 14.9 17.6214 17.9222C14.5991 20.9444 9.69915 20.9444 6.67692 17.9222C3.6547 14.9 3.6547 10 6.67692 6.97778C9.69915 3.95556 14.5991 3.95556 17.6214 6.97778Z" fill="currentColor"></path>
                  </g>
                </svg>
              </span>Search
            </a>
          </li>
          <li>
            <a href={(isAuthenticated && talent) ? `/talent/dashboard` : `/login`}>
              <span>
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <g>
                      <path fillRule="evenodd" clipRule="evenodd" d="M16.9 15.5H8.89996C6.69082 15.5 4.89996 17.2909 4.89996 19.5V20.5H20.9V19.5C20.9 17.2909 19.1091 15.5 16.9 15.5ZM8.89996 13.5C5.58626 13.5 2.89996 16.1863 2.89996 19.5V22.5H22.9V19.5C22.9 16.1863 20.2137 13.5 16.9 13.5H8.89996Z" fill="currentColor"></path>
                      <path fillRule="evenodd" clipRule="evenodd" d="M12.9 10.5C14.5568 10.5 15.9 9.15685 15.9 7.5C15.9 5.84315 14.5568 4.5 12.9 4.5C11.2431 4.5 9.89996 5.84315 9.89996 7.5C9.89996 9.15685 11.2431 10.5 12.9 10.5ZM12.9 12.5C15.6614 12.5 17.9 10.2614 17.9 7.5C17.9 4.73858 15.6614 2.5 12.9 2.5C10.1385 2.5 7.89996 4.73858 7.89996 7.5C7.89996 10.2614 10.1385 12.5 12.9 12.5Z" fill="currentColor"></path>
                    </g>
                  </g>
                </svg>
              </span>Profile
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
